export default __webpack_public_path__ + "files/RP1_EU_policy_instruments_for_bioeconomy_development_and_link_to_wider_sustainability_ambitions.docx";